/* ==========================================================
   NAVA HEADER
========================================================== */

document.addEventListener('DOMContentLoaded', () => {

    const dropdowns = document.querySelectorAll('.has-dropdown');

    dropdowns.forEach(item => {

        const link = item.querySelector('.nava-nav__link');

        if (!link) return;

        link.addEventListener('focus', () => {
            item.classList.add('is-open');
        });

        item.addEventListener('mouseleave', () => {
            item.classList.remove('is-open');
        });

    });

});